import React from "react";

import "./small-Loader.scss";

const SmallLoader = ({ size, borderSize, margin }) => {
  return (
    <div
      className="small-loader-component"
      style={{
        width: size,
        height: size,
        borderWidth: borderSize,
        margin: margin,
      }}
    ></div>
  );
};

export default SmallLoader;
